import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "kann_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (value) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }).format(value || 0);

// Route an image through the backend optimizer: resized WebP + long cache.
// Skips data/blob URLs, already-proxied URLs, and SVG/GIF uploads.
export function img(url, w = 1200) {
  if (!url || typeof url !== "string") return url;
  const u = url.trim();
  const raw = u.includes("/api/files/") && /\.(svg|gif)(\?|$)/i.test(u);
  if (!u || u.startsWith("data:") || u.startsWith("blob:") || u.includes("/api/img?") || raw) {
    return raw && u.startsWith("/") ? `${BACKEND_URL}${u}` : u;
  }
  const abs = u.startsWith("/") ? `${BACKEND_URL}${u}` : u;
  return `${API}/img?url=${encodeURIComponent(abs)}&w=${w}`;
}

export const colorHex = {
  White: "#FFFFFF",
  Black: "#18181B",
  Grey: "#A1A1AA",
};

// Absolute URL for a stored file (e.g. "/api/files/…") so it can be downloaded directly.
export function fileUrl(url) {
  if (!url || typeof url !== "string") return url;
  return url.startsWith("/") ? `${BACKEND_URL}${url}` : url;
}

export async function fetchInvoiceUrl(orderId) {
  const res = await api.get(`/orders/${orderId}/invoice`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function downloadInvoice(orderId, invoiceNumber) {
  const res = await api.get(`/orders/${orderId}/invoice`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `invoice-${invoiceNumber || orderId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function fetchWorksheetUrl() {
  const res = await api.get(`/admin/product-worksheet.pdf`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function downloadWorksheet() {
  const res = await api.get(`/admin/product-worksheet.pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "KANN-product-invulformulier.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function fetchFlyerUrl(lang = "nl", layout = "single") {
  const res = await api.get(`/admin/flyer.html`, { params: { lang, layout }, responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function downloadFlyer(lang = "nl", layout = "single") {
  const res = await api.get(`/admin/flyer.html`, { params: { lang, layout }, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `KANN-flyer-${lang}${layout === "a4x2" ? "-A4x2" : ""}.html`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadSubscribersCsv() {
  const res = await api.get(`/newsletter/export.csv`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "kann-newsletter-subscribers.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadManualInvoice(payload) {
  const res = await api.post(`/admin/manual-invoice.pdf`, payload, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `KANN-${(payload.invoice_number || "factuur").replace(/[\/ ]/g, "-")}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}


export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
